import { BaseRule } from "@presidents/game-engine/src/rules";

export const RuleLabels: Record<BaseRule, string> = {
  shouldSwap: "Card Swapping",
  shouldAutoSwap: "Auto Card Swapping",
  shouldSkip: "Miss-A-Go",
  sixtyNine: "Sixty-Nine",
  fourOfAKindRevolution: "Revolution",
  largerSetBeatsSmallerSet: "Larger set beats smaller set",
  twoWinsTrick: "2 Clears"
};

export const RuleDescription: Record<BaseRule, string> = {
  shouldSwap:
    "The Asshole must swap their highest card with the Presidents lowest card",
  shouldAutoSwap:
    "The Asshole automatically swaps their highest card with the Presidents lowest card",
  shouldSkip:
    "Playing the same card (or cards) as the previous play skips the next player",
  sixtyNine: "Playing a 6 and a 9 will beat anything in play",
  fourOfAKindRevolution:
    "Playing four cards of the same value in a row clears the pile! Players can play the remaining cards out-of-turn",
  largerSetBeatsSmallerSet:
    "Playing a larger set (number of cards) beats a smaller set even if the value of the smaller set is higher e.g. three 3s beats two 10s",
  twoWinsTrick: "Playing a single 2 clears the pile!"
};
